import {FC, PropsWithChildren} from 'react'

import GlobalStyles from '@mui/material/GlobalStyles'
import {motion} from 'framer-motion'
import {makeStyles} from 'tss-react/mui'

import {Portal} from '@progyny/components/Portal'

type Props = {close?: () => void; open?: boolean}

const useStyles = makeStyles()((theme) => ({
  main: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    width: '100vw',
    zIndex: 140,
    padding: 0,
    backgroundColor: 'white',
    overflow: 'auto',
  },
  wrapper: {
    padding: `${theme.palette.other.constValues.appHeaderHeight}px 0`,
  },
}))

const Overlay: FC<PropsWithChildren<Props>> = ({children, open}) => {
  const {classes} = useStyles()

  return (
    <Portal idPrefix='overlay'>
      {open && (
        <>
          <GlobalStyles
            styles={{
              body: {
                overflow: 'hidden',
                height: '100vh',
              },
            }}
          />
          <motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{duration: 0.3}}
            exit={{opacity: 0}}
            className={classes.main}
          >
            <div className={classes.wrapper}>{children}</div>
          </motion.div>
        </>
      )}
    </Portal>
  )
}
export {Overlay}
